import type { CSSProperties } from 'react'
import './ui.css'
// 标志 LN「开放折线」的矢量母版在 lingzhi-design（scripts/formats/logo.mjs），这里直接用它生成的 SVG
import markUrl from '@lingzhi/design-tokens/logo/ln-mark.svg'

/** 灵智原生的标志。用 SVG 当遮罩，颜色跟着 --lingzhi-logo-mark-fg 走（浅色墨黑、深色米白），高度取令牌。
 *  旁边已经写了「灵智原生」时不用传 label，标志只是装饰；单独出现时传 label 给读屏。 */
export function BrandMark({ size = 'sm', label }: { size?: 'sm' | 'lg'; label?: string }) {
  return (
    <span
      className="brand-mark"
      data-size={size}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      style={{ '--brand-mark-url': `url("${markUrl}")` } as CSSProperties}
    />
  )
}
